import Col from './src/col';

module.exports = Col



// WEBPACK FOOTER //
// ./src/components/col/index.js